<template>


<footer class="container-fluid">
    <div class="footer-list row">
        <div class="footer-list-item col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
<!--             <h6 class="main-footer-label">BRANDS</h6>
            <ul>
                <li><a title="Dawncoffee" target="_blank" href="https://dawncoffee.com">Dawncoffee
          </a></li>
                <li>
                    <a title="Interestelar" target="_blank" href="https://interestelar.cl">Interestelar
                    </a>
                </li>
            </ul> -->
        </div>
        <!--       <div class="footer-list-item col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
        <h6 class="main-footer-label">Corporativo</h6>
        <ul>
        </ul>
      </div> -->
        <div class="footer-list-item col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
<!--             <h6 class="main-footer-label">Hablemos</h6>
            <ul>
                <li>
                    <a href="mailto:hola@hackdagio.xyz" class="link-with-icon">

                        hola@hackdagio.xyz</a>
                </li>
                <li>
                    <a href="https://t.me/hackdagio" target="_blank" class="link-with-icon">
                         @hackdagio en Telegram
                    </a>
                </li>
            </ul> -->
        </div>

        <div class="footer-list-item social-list col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <img style='height:12px; margin-bottom:12px;' class='hackdagio-main-logo' src="static/img/logos/hackdagio.svg" alt="HACKDAGIO">

            <p class="legend-footer-label"><strong style="display:none;">HACKDAGIO is </strong><span style="text-transform:uppercase">a</span> software company based in Santiago de Chile</p>
            <hr />
            <!--         <h6 class="main-footer-label">Síguenos</h6> -->
            <ul>
                <li>
                    <a href="https://twitter.com/hackdagio" target="_blank" class="stalk-icon">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" x="0px" y="0px" viewBox="0 -0.001 30 21" overflow="visible" enable-background="new 0 -0.001 30 21" xml:space="preserve" class="social-icon social-twitter">
                            <defs></defs>
                            <path d="M30,9.542c-1.057,0.179-2.586-0.007-3.398-0.347c1.687-0.139,2.828-0.905,3.269-1.946
                  c-0.606,0.374-2.496,0.782-3.537,0.394c-0.051-0.246-0.106-0.479-0.164-0.69c-0.793-2.916-3.512-5.268-6.356-4.984
                  c0.227-0.093,0.461-0.178,0.694-0.257c0.312-0.112,2.152-0.414,1.863-1.062c-0.246-0.571-2.492,0.432-2.916,0.563
                  c0.56-0.21,1.481-0.57,1.582-1.214c-0.854,0.118-1.695,0.523-2.345,1.112c0.232-0.253,0.41-0.56,0.447-0.891
                  c-2.281,1.46-3.615,4.401-4.694,7.256c-0.847-0.822-1.6-1.469-2.272-1.831c-1.891-1.012-4.15-2.07-7.697-3.389
                  C4.367,3.43,5.056,4.995,7.039,6.032C6.611,5.974,5.824,6.103,5.195,6.254c0.257,1.348,1.093,2.455,3.359,2.991
                  C7.52,9.311,6.984,9.55,6.5,10.058c0.471,0.936,1.624,2.037,3.691,1.812c-2.302,0.992-0.938,2.832,0.936,2.561
                C7.932,17.734,2.893,17.488,0,14.726c7.553,10.305,23.975,6.092,26.42-3.832C28.254,10.908,29.332,10.259,30,9.542z"></path>
                        </svg>
                    </a>

<!--                     <a href="http://www.facebook.com/hackdagiohq" target="_blank" class="stalk-icon">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" x="0px" y="0px" viewBox="-8.372 0 30 30" overflow="visible" enable-background="new -8.372 0 30 30" xml:space="preserve" class="social-icon social-facebook">
                            <defs></defs>
                            <path d="M9.308,30H3.102V15H0v-5.17h3.102V6.726C3.102,2.509,4.853,0,9.826,0h4.143v5.17H11.38
                c-1.938,0-2.064,0.723-2.064,2.071L9.308,9.829h4.689L13.449,15H9.308V30z"></path>
                        </svg>
                    </a> -->

                    <a href="https://www.linkedin.com/company/hackdagio" target="_blank" class="stalk-icon">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 18" enable-background="new 0 0 20 18" xml:space="preserve" class="social-icon social-linked-in">
                            <g>
                                <rect x="0.8" y="6" width="4" height="12"></rect>
                                <path d="M2.8,4.4L2.8,4.4c-1.4,0-2.2-0.9-2.2-2.1c0-1.2,0.9-2.1,2.3-2.1c1.4,0,2.2,0.9,2.2,2.1
                  C5.1,3.4,4.2,4.4,2.8,4.4z"></path>
                                <path d="M19.2,18h-4v-6.4c0-1.6-0.6-2.7-2-2.7c-1.1,0-1.8,0.7-2,1.5c-0.1,0.3-0.1,0.6-0.1,1V18H7C7,18,7.1,7.1,7,6
                  h4v1.7c0.5-0.8,1.5-2,3.6-2c2.6,0,4.6,1.7,4.6,5.4V18z"></path>
                            </g>
                        </svg>
                    </a>
                    <a href="https://instagram.com/hackdagio/" title="Instagram" class="stalk-icon" target="_blank">
                        <svg viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="social-icon social-instagram">
                            <path d="M18.5855434,9.35883181 L16.8479423,9.35883181 C16.9745691,9.85144265 17.0519522,10.3651654 17.0519522,10.9 C17.0519522,14.2990148 14.2943018,17.0576355 10.8964826,17.0576355 C7.49866338,17.0576355 4.74101301,14.2990148 4.74101301,10.9 C4.74101301,10.3651654 4.81839606,9.85144265 4.94502286,9.35883181 L3.20742174,9.35883181 L3.20742174,17.8247009 C3.20742174,18.2469388 3.55212803,18.5917664 3.97421738,18.5917664 L17.8187478,18.5917664 C18.2408371,18.5917664 18.5855434,18.2469388 18.5855434,17.8247009 L18.5855434,9.35883181 L18.5855434,9.35883181 L18.5855434,9.35883181 Z M18.5855434,3.97529909 C18.5855434,3.55306122 18.2408371,3.20823364 17.8187478,3.20823364 L15.5113261,3.20823364 C15.0892367,3.20823364 14.7445304,3.55306122 14.7445304,3.97529909 L14.7445304,6.28353272 C14.7445304,6.70577058 15.0892367,7.05059817 15.5113261,7.05059817 L17.8187478,7.05059817 C18.2408371,7.05059817 18.5855434,6.70577058 18.5855434,6.28353272 L18.5855434,3.97529909 L18.5855434,3.97529909 Z M10.8964826,7.05059817 C8.77196623,7.05059817 7.04843475,8.7747361 7.04843475,10.9 C7.04843475,13.0252639 8.77196623,14.7494018 10.8964826,14.7494018 C13.0209989,14.7494018 14.7445304,13.0252639 14.7445304,10.9 C14.7445304,8.7747361 13.0209989,7.05059817 10.8964826,7.05059817 L10.8964826,7.05059817 Z M18.5855434,20.9 L3.20742174,20.9 C1.93411889,20.9 0.9,19.8655172 0.9,18.5917664 L0.9,3.20823364 C0.9,1.93448276 1.93411889,0.9 3.20742174,0.9 L18.5925783,0.9 C19.8658811,0.9 20.9,1.93448276 20.9,3.20823364 L20.9,18.5988037 C20.8929652,19.8655172 19.8658811,20.9 18.5855434,20.9 L18.5855434,20.9 Z"></path>
                        </svg>
                    </a>
                    <a href="https://github.com/hackdagio" title="Github" class="stalk-icon" target="_blank">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 22.9 " xml:space="preserve" class="social-icon social-github">
                            <path d="M21.9,0c0.4,0.9,0.6,2.3,0.3,3.4c1.5,1.3,2.1,4.5,1.3,7.1c2.2,0.2,4.8-0.1,6.5,0.6c-1.6-0.2-3.7-0.6-5.8-0.5
  c-0.4,0-1,0-0.9,0.5c2.4,0.2,4.7,0.4,6.6,1c-1.9-0.3-4.2-0.8-6.6-0.9c-1,1.9-3,2.9-5.7,3.1c0.3,0.6,0.9,0.9,1,1.9
  c0.2,1.5-0.3,3.8,0.2,4.8c0.2,0.5,0.7,0.5,0.9,0.9c-0.7,0.8-2.3-0.1-2.5-0.9c-0.3-1.4,0.5-3.6-0.4-4.6c0.1,1.6-0.4,3.7,0.1,5.1
  c0.2,0.5,0.7,0.8,0.5,1.2c-3.1,0.3-1.8-4-2.3-6.6c-0.5,0-0.3,0.7-0.3,1c0,2.5,0.5,5.9-2.2,5.6c-0.1-0.5,0.4-0.7,0.5-1.2
  c0.5-1.4-0.1-3.5,0.1-5.2c-1,0.8,0.1,3.5-0.5,4.9c-0.4,0.8-1.6,1.1-2.5,0.8c0.1-0.6,0.7-0.5,1-1.1c0.4-0.8,0-1.9,0.1-3
  C9.5,18.5,8,18,7.3,16.8c-0.3-0.5-0.4-1.2-0.8-1.6c-0.4-0.5-1-0.5-1.2-1.2c2.4-0.6,2.5,2.4,4.6,2.5c0.6,0,1-0.2,1.6-0.3
  c0.2-0.8,0.5-1.3,1.1-1.7c-2.6-0.4-4.8-1.2-5.8-3.2c-2.4,0.1-4.6,0.4-6.6,0.9c1.8-0.7,4.1-0.9,6.6-1c-0.1-0.9-1.4-0.6-2.2-0.6
  C3,10.7,1.2,10.9,0,11.1c1.7-0.6,4-0.5,6.3-0.5C5.6,8.4,5.9,5,7.4,3.7C6.9,2.6,7.1,0.8,7.6,0c1.7,0.1,2.7,0.8,3.8,1.5
  c1.3-0.4,2.7-0.6,4.5-0.5c0.8,0,1.5,0.4,2.1,0.3c0.6-0.1,1.2-0.7,1.7-0.9C20.5,0.1,21.1,0,21.9,0L21.9,0z" />
                        </svg>
                    </a>
<!--                     <a href="https://vimeo.com/hackdagio" title="Vimeo" class="stalk-icon" target="_blank">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20.847 20.847" xml:space="preserve" class="social-icon social-vimeo">
                            <g>
                                <path d="M17.811,2.018c2.017,0.053,3.026,1.198,3.036,3.438c0,0.147-0.005,0.3-0.013,0.457c-0.089,1.899-1.502,4.486-4.245,7.76   c-2.829,3.43-5.229,5.147-7.2,5.156c-1.226,0-2.244-1.05-3.061-3.151l-0.858-2.88L4.622,9.922C3.997,7.838,3.329,6.798,2.616,6.798   c-0.156,0-0.697,0.304-1.626,0.91L0,6.537l1.536-1.276l1.511-1.263C4.4,2.914,5.429,2.328,6.135,2.241   c0.094-0.01,0.188-0.013,0.284-0.013c1.449,0,2.354,1.041,2.709,3.124C9.326,6.54,9.49,7.506,9.623,8.248   C9.752,8.992,9.86,9.51,9.946,9.805c0.479,1.97,0.995,2.96,1.55,2.968c0.426,0,1.082-0.642,1.968-1.926   c0.866-1.319,1.332-2.296,1.392-2.932c0.019-0.129,0.026-0.25,0.026-0.362c0-0.861-0.474-1.29-1.418-1.29   c-0.479,0-0.99,0.102-1.537,0.299c0.98-3.021,2.864-4.534,5.65-4.544C17.655,2.018,17.732,2.018,17.811,2.018z" />
                            </g>
                        </svg>
                    </a> -->
                </li>
            </ul>
        </div>
    </div>
    <div class="main-footer-extras">
        <a href="https://brew.engineering"><span class="copyright-wrap">
      © 2020
      <span class="brew-copyright" itemscope="" itemtype="http://schema.org/Organization">
        <span itemprop="name">Hackdagio</span>
        <link itemprop="url" href="https://hackdagio.com/">
        <link itemprop="sameAs" href="https://twitter.com/hackdagio">
        </span> SpA
        </span><br /><small>Los Abedules 3085, Vitacura, Chile</small></a>
        <!--     <span class="footer-links-wrap">
        <a href="/sitemap">Sitemap</a>
        <a href="/contact">Contáctanos</a>
      </span> -->
    </div>
    </div>
</footer>


</template>


<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


footer {
    background-color: black;
    color: #8c8c8c;
    padding-top: 4em;
    padding-bottom:2em;
}

/*  footer {
    position: relative;
    background: url('/static/img/world-a.svg'), #1d0124;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  footer:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(to top, #16181c, black);
  opacity: .9;
}*/
/*@media all and (min-width: 992px) {

}*/
footer a {
    color: #919191;
    text-decoration: none
}
footer a:hover {
    color: #fff
}
footer a:hover svg {
    fill: #fff
}
.title-footer-items {
    margin-bottom: 1.2em;
    font-weight: bold;
}
.title-footer-items a {
    color: #fff;
}
/*.footer-top-shelf-links {
    height: 216px
}*/
@media (max-width: 550px) {
    .footer-top-shelf-links {
        height: auto
    }
}
footer .stalk-icon {
    vertical-align: text-top;
    display: inline-block
}
footer a svg {
    margin-top: -4px;
    fill: #919191
}
footer .four-columns .column {
    padding-right: 0
}
footer .column ul {
    margin-bottom: 2em;
    list-style-type: none;
    padding-left: 0;
    margin-left: 0
}
footer .column ul strong {
    color: white
}
footer .column li {
    padding-bottom: .6em;
    list-style-type: none;
    padding-left: 0;
    margin-left: 0
}
footer .column li .cart_icon {
    margin-top: 5px;
    display: inline-block;
    height: 18px;
    width: 24px;
    fill: #919191
}
footer .column li .cart_icon:hover {
    fill: #fff
}
.media-kit {
    margin-top: 10px
}
.media-kit a {
    display: flex;
    align-items: center
}
.media-kit svg {
    margin-right: 10px;
    margin-left: 10px
}

@media (max-width: 767px) {
    .revealing-footer {
        position: relative;
        bottom: auto;
        opacity: 1;
        z-index: 1
    }
}
.main-footer-label {
    font-weight: normal;
    text-transform: uppercase;
    color: white;
    letter-spacing: 2px;
    margin-bottom:1em;
}
.main-footer-label:not(:first-child) {
    margin-top: 4vw;
}

.main-footer-extras {
    font-size: inherit;
    padding: 2em 0;
    text-align: center;
    clear: both;
    margin-bottom: -8px;
    position: relative;
    opacity: 0.5;
}
@media (max-width: 767px) {
    .copyright-wrap,
    .footer-links-wrap {
        text-align: center;
        display: block
    }
}
.footer-links-wrap {
  border-left: 1px dotted rgba(255, 255, 255, 0.4);
  margin-left: 1em;
  font-size: 80%;
}
.main-footer-extras a {
    margin-left: 1em
}
@media all and (max-width: 768px) {
  .footer-links-wrap {
    border-left: none;
    display: block;
    margin-left: 0;
    margin-top: 1em;
  }
}


@media (max-width: 767px) {
    .main-footer-extras a {
        margin-right: 7px;
        margin-left: 7px
    }
}
.main-footer-snip-479 {
    display: none
}
.social-icon {
    display: inline-block;
    vertical-align: middle;
    height: 18px;
    width: auto;
    fill: rgba(255, 150, 0, 0.4);
    margin: 0 4px
}
.social-medium,
.social-github {
    height: 20px
}
.social-facebook {
    margin: 0
}
.social-icon:hover,
.cart_icon {
    fill: rgba(255, 150, 0, 0.8);
}
.hidden {
    display: none
}
@media only screen and (max-width: 479px) {
    footer {
        font-size: 12px;
        letter-spacing: .03em
    }
    .main-footer-snip {
        display: none
    }
    .main-footer-snip-479 {
        display: none
    }
}

.footer-list {
  margin-bottom: 2em;
}

.footer-list-item {
  padding: 0 4vw;
}
@media all and (max-width: 575px) {
  .footer-list-item {
    text-align: center;
    margin-bottom: 6vw;
  }
  .main-footer-label:not(:first-child) {
    margin-top: 6vw;
  }
}
@media all and (max-width: 768px) {
  .footer-list-item {
    text-align: center;
    margin-bottom: 3vw;
  }
  .main-footer-label:not(:first-child) {
    margin-top: 3vw;
  }
}
@media all and (max-width: 991px) {

  .footer-list-item {
    text-align: left;
    margin-bottom: 6vw;
    padding-left: 2em;
  }
  .main-footer-label:not(:first-child) {
    margin-top: 6vw;
  }
}
@media all and (min-width: 992px) {
  .social-list {
    text-align: right;
  }
}

.img-on-list {
  margin-bottom:.5em;
  opacity:0.5;
  transition: opacity 250ms ease-in-out;
}
.img-on-list:hover {
  opacity:1;
}

.legend-footer-label {
  font-weight: lighter;
  color: rgba(255,255,255,0.9);
}

.side-icon {
  opacity: 0.5;
  width: 5em;
  transition: opacity 250ms ease-in-out; }

.side-icon:hover
{
  opacity: 1;
}

.hiper-icon {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: auto;
    fill: #c05009;
    margin: 0 4px;
}

.hiper-icon.hiper-telegram {
  width: 16px;
  margin-right: 8px;
}

.link-with-icon {
  display: inline-flex;
justify-content: flex-start;
align-items: center;
flex-direction: row;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue